import React from 'react';
import PropTypes from 'prop-types';
import css from './Button.module.css';

const Button = ({ 
  variant = 'primary', 
  className = '', 
  text = 'Join now',
  onClick,
  ...props 
}) => {
  return (
    <button 
      className={`${css.button} ${css[variant]} ${className}`}
      onClick={onClick}
      {...props}
    >
      <div className={css.callToAction}>{text}</div>
    </button>
  );
};

Button.propTypes = {
  variant: PropTypes.oneOf(['primary', 'secondary']),
  className: PropTypes.string,
  text: PropTypes.string,
  onClick: PropTypes.func,
};

export default Button;

